export const INPUT_LIMITS = {
  TEXT: {
    TITLE_MAX: 250,
    DESCRIPTION_MAX: 2000,
    LONG_TEXT_MAX: 5000,
    FIRST_NAME:100,
    LAST_NAME:100,
  },
  IMAGES: {
    MAX_COUNT: 5,
    MAX_SIZE_BYTES: 5 * 1024 * 1024,
    SUPPORTED_EXTENSIONS: ["jpg", "jpeg", "png", "webp", "svg", "gif"],
  },
  VIDEOS: {
    MAX_COUNT: 1,
    MAX_SIZE_BYTES: 25 * 1024 * 1024,
    SUPPORTED_EXTENSIONS: ["mp4", "webm", "mov"],
  },
  DOCUMENTS: {
    MAX_COUNT: 1,
    MAX_SIZE_BYTES: 25 * 1024 * 1024,
    SUPPORTED_EXTENSIONS: ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"],
  },

  PROFILE: {
    AVATAR_MAX_COUNT: 1,
    COVER_MAX_COUNT: 1,
  },
};
export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/svg+xml',
  'image/gif',
];
export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/webm',
  'video/quicktime',
];
